import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  details: null,
}

export const fisheriesListSlice = createAppSlice({
  name: 'fisheriesList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag.size = payload.size
      state.tag.page = payload.page
    }),
  }),
})

export const { setFetchOption } = fisheriesListSlice.actions

export default fisheriesListSlice.reducer
